import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';
import { Observable } from 'rxjs';
import { GenericDocWrapperContainerModel } from '../../../../../../models/aggregates/generic_doc';

@Injectable({
  providedIn: 'root'
})
export class MultiDocService extends BaseApiTemplateService<GenericDocWrapperContainerModel> {

  readonly url =
    Core2Config.LOCAL_HOST + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX +  'multi-doc';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX +  'multi-doc';
    this.httpClient = http;
  }

  public multiDocOperation(
    visa: ApiVisa,
    genericDocWrapperContainerList: GenericDocWrapperContainerModel[]
  ): Observable<ApiResponseModel<GenericDocWrapperContainerModel[]>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const Url = this.apiUrl;
    return this.httpClient.post<ApiResponseModel<GenericDocWrapperContainerModel[]>>
      (Url,
        genericDocWrapperContainerList,
        this.getHttpHeader(visa));
  }
}
